<template>
  <b-loading v-model="isLoading" :can-cancel="false"></b-loading>
</template>

<script>
import { useUserStore } from '@/stores/userStore'

export default {
  name: 'TokenReset',
  data: function () {
    return {
      isLoading: true,
    }
  },
  mounted () {
    const userStore = useUserStore()
    userStore.logout()
    this.$cookies.remove("teamwrkr-token");
    this.redirectToWelcome();
  },
  methods: {
    redirectToWelcome () {
      this.$router.push(`/welcome`);
    }
  },
}
</script>

